import { createUseStyles } from 'react-jss';

export default createUseStyles((theme: { colorPrimary: string }) => ({

  channel: {
    background: '#ffffff',
    borderRadius: 8,
    marginBottom: 18,
    boxShadow: '0 1px 2px rgba(0,0,0,.06),0 2px 8px rgba(0,0,0,.08)',
    overflow: 'hidden',
  },
  channelBar: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '14px 18px',
    borderBottom: '1px solid #f0f0f0',
  },
  channelIcon: {
    width: 30,
    height: 30,
    borderRadius: 7,
    display: 'grid',
    placeItems: 'center',
    color: '#fff',
    fontSize: 15,
    flex: 'none',
  },
  channelIconMail: { background: theme.colorPrimary },
  channelIconWsp: { background: '#25d366' },
  channelTitle: { fontSize: 15, fontWeight: 700, lineHeight: 1.2 },
  channelCount: { fontSize: 12, color: '#8c8c8c', marginTop: 1 },
  channelInner: { padding: '14px 18px 18px' },
  cap: {
    fontSize: 11,
    color: '#8c8c8c',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '.5px',
    margin: '0 0 10px',
  },

  carousel: {
    display: 'flex',
    gap: 13,
    overflowX: 'auto',
    padding: '2px 2px 12px',
    scrollSnapType: 'x mandatory',
    '&::-webkit-scrollbar': { height: 8 },
    '&::-webkit-scrollbar-thumb': { background: '#d0d0d0', borderRadius: 8 },
  },
  scard: {
    flex: '0 0 210px',
    scrollSnapAlign: 'start',
    border: '1px solid #d9d9d9',
    borderRadius: 8,
    background: '#fff',
    overflow: 'hidden',
    transition: '.15s',
    display: 'flex',
    flexDirection: 'column',
  },
  scardOff: { opacity: 0.6 },
  scardTop: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '11px 12px 9px',
  },
  scode: {
    fontFamily: "'SF Mono',ui-monospace,'Menlo',Consolas,monospace",
    fontSize: 11,
    fontWeight: 700,
    color: '#fff',
    background: '#595959',
    borderRadius: 5,
    padding: '1px 7px',
    flex: 'none',
  },
  scodeOn: { background: theme.colorPrimary },
  sname: { fontSize: 13.5, fontWeight: 700, color: '#1f1f1f', lineHeight: 1.2 },
  swToggle: { marginLeft: 'auto', flex: 'none' },
  thumb: {
    height: 132,
    margin: '0 12px',
    border: '1px solid #f0f0f0',
    borderRadius: 6,
    overflow: 'hidden',
    background: '#fafafa',
  },
  plName: {
    fontSize: 11.5,
    color: '#595959',
    padding: '8px 12px 2px',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    flexWrap: 'wrap',
  },
  plTag: {
    fontSize: 9.5,
    fontWeight: 700,
    color: theme.colorPrimary,
    background: '#e6f7f6',
    border: '1px solid #8fded9',
    borderRadius: 4,
    padding: '0 5px',
    fontFamily: "'SF Mono',ui-monospace,'Menlo',Consolas,monospace",
  },
  sbtns: {
    display: 'flex',
    gap: 6,
    padding: '8px 12px 12px',
    marginTop: 'auto',
    '& button': { flex: 1 },
  },
  addcard: {
    flex: '0 0 150px',
    border: '1px dashed #d9d9d9',
    borderRadius: 8,
    background: 'transparent',
    display: 'grid',
    placeItems: 'center',
    color: '#595959',
    cursor: 'pointer',
    scrollSnapAlign: 'start',
    textAlign: 'center',
    transition: '.15s',
    '&:hover': {
      borderColor: theme.colorPrimary,
      color: theme.colorPrimary,
      background: '#e6f7f6',
    },
  },

  mini: { padding: 9, fontSize: 8, height: '100%' },
  miniHead: {
    height: 20,
    borderRadius: '3px 3px 0 0',
    display: 'flex',
    alignItems: 'center',
    padding: '0 7px',
    color: '#fff',
    fontWeight: 700,
    fontSize: 7.5,
    justifyContent: 'space-between',
    background: theme.colorPrimary,
  },
  miniBody: {
    background: '#fff',
    border: '1px solid #eee',
    borderTop: 'none',
    padding: 7,
    borderRadius: '0 0 3px 3px',
  },
  miniTitle: { fontWeight: 700, color: '#222', fontSize: 9, margin: '2px 0 5px' },
  miniLine: { height: 4, background: '#ececec', borderRadius: 3, margin: '3px 0' },
  miniBtn: { height: 11, width: '66%', borderRadius: 3, margin: '7px auto 2px' },
  wmini: {
    padding: 10,
    background: '#e5ddd5',
    height: '100%',
    backgroundImage: 'radial-gradient(rgba(0,0,0,.03) 1px,transparent 1px)',
    backgroundSize: '8px 8px',
  },
  bubble: {
    background: '#fff',
    borderRadius: 8,
    padding: 7,
    fontSize: 8,
    boxShadow: '0 1px 1px rgba(0,0,0,.1)',
  },
  bubbleTitle: { fontWeight: 700, color: '#222', marginBottom: 3 },
  bubbleLine: { height: 4, background: '#eee', borderRadius: 3, margin: '3px 0' },
  bubbleBtn: {
    marginTop: 5,
    borderTop: '1px solid #eee',
    paddingTop: 4,
    color: '#25d366',
    textAlign: 'center',
    fontWeight: 700,
  },

  note: {
    fontSize: 12,
    color: '#595959',
    background: '#e6f7f6',
    border: '1px solid #8fded9',
    borderRadius: 6,
    padding: '9px 12px',
    display: 'flex',
    gap: 8,
    alignItems: 'flex-start',
    marginTop: 12,
    '& b': { color: theme.colorPrimary },
  },
  inheritBanner: {
    fontSize: 12.5,
    color: '#595959',
    background: '#fffbe6',
    border: '1px solid #ffe58f',
    borderRadius: 6,
    padding: '10px 14px',
    margin: '0 0 4px',
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  editor: {
    display: 'grid',
    gridTemplateColumns: '300px 1fr',
    minHeight: 460,
    '@media(max-width:760px)': { gridTemplateColumns: '1fr' },
  },
  blocks: {
    borderRight: '1px solid #f0f0f0',
    padding: 14,
    background: '#fafafa',
    overflow: 'auto',
  },
  blk: {
    background: '#fff',
    border: '1px solid #d9d9d9',
    borderRadius: 6,
    marginBottom: 8,
    overflow: 'hidden',
    cursor: 'pointer',
  },
  blkSel: {
    borderColor: theme.colorPrimary,
    boxShadow: '0 0 0 2px rgba(13,184,178,.18)',
  },
  blkHead: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '9px 10px',
    fontSize: 12,
  },
  blkType: { fontWeight: 700, color: '#1f1f1f' },
  blkVal: {
    color: '#8c8c8c',
    marginLeft: 'auto',
    fontSize: 11,
    maxWidth: 96,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  blkEdit: {
    borderTop: '1px solid #f0f0f0',
    padding: 10,
    background: '#f5f7f8',
  },
  vchips: { display: 'flex', flexWrap: 'wrap', gap: 5, marginTop: 8 },
  vchip: {
    fontSize: 10.5,
    fontFamily: "'SF Mono',ui-monospace,'Menlo',Consolas,monospace",
    color: theme.colorPrimary,
    background: '#e6f7f6',
    border: '1px solid #8fded9',
    borderRadius: 4,
    padding: '1px 6px',
    cursor: 'pointer',
    '&:hover': { background: theme.colorPrimary, color: '#fff' },
  },
  fldLbl: {
    fontSize: 11,
    fontWeight: 700,
    color: '#434b52',
    margin: '14px 0 6px',
    textTransform: 'uppercase',
    letterSpacing: '.3px',
  },
  palette: { display: 'flex', gap: 6 },
  csw: {
    width: 22,
    height: 22,
    borderRadius: 5,
    border: '1px solid rgba(0,0,0,.12)',
    cursor: 'pointer',
  },
  cswOn: { outline: `2px solid ${theme.colorPrimary}`, outlineOffset: 1 },
  previewPane: {
    padding: 22,
    background: '#eceff1',
    overflow: 'auto',
    display: 'grid',
    placeItems: 'start center',
  },

  email: {
    background: '#fff',
    borderRadius: 8,
    overflow: 'hidden',
    boxShadow: '0 4px 14px rgba(0,0,0,.12)',
  },
  emailHead: {
    padding: '16px 20px',
    color: '#fff',
    fontWeight: 700,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  emailBody: { padding: 20 },
  emailBtn: {
    display: 'block',
    textAlign: 'center',
    color: '#fff',
    padding: 11,
    borderRadius: 6,
    fontWeight: 600,
    fontSize: 13,
    marginTop: 6,
  },
  emailFoot: {
    padding: '14px 20px',
    background: '#fafafa',
    borderTop: '1px solid #eee',
    fontSize: 11,
    color: '#999',
    textAlign: 'center',
  },
  var: {
    background: '#e6f7f6',
    color: theme.colorPrimary,
    borderRadius: 3,
    padding: '0 3px',
    fontWeight: 600,
  },
  editorHint: {
    background: '#fff',
    borderTop: '1px solid #f0f0f0',
    padding: '9px 14px',
    fontSize: 11.5,
    color: '#8c8c8c',
  },

  maprow: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 12,
    padding: '9px 2px',
    borderBottom: '1px solid #f0f0f0',
    fontSize: 13,
    alignItems: 'center',
  },
  mapKey: {
    color: '#595959',
    fontFamily: "'SF Mono',ui-monospace,'Menlo',Consolas,monospace",
    fontSize: 12,
  },
  mapArrow: { color: '#8c8c8c' },
  mapVal: {
    color: theme.colorPrimary,
    fontFamily: "'SF Mono',ui-monospace,'Menlo',Consolas,monospace",
    fontSize: 12,
    fontWeight: 600,
  },
  mapComp: {
    fontSize: 10.5,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '.4px',
    color: '#8c8c8c',
    margin: '14px 0 2px',
  },
}));
